<template>
  <a-modal
    v-model:visible="mVisible"
    width="760px"
    title="预约记录"
    :footer="null"
    :body-style="{ padding: 0 }"
  >
    <div class="aDetailWrap">
      <a-row type="flex" class="top cL" justify="space-between">
        <div class="top-left">
          <auth-img :src="curInfo.patientHeadUrl" mode="scaleToFill" />
          <div>
            <div class="up">
              <span class="pat">患者</span>
              <span class="up-t">{{ curInfo.patientProfileCommonVO?.patientProfileName }}</span>
            </div>
            <div class="bot">ID: {{ curInfo.patientProfileCommonVO?.patientProfileId }}</div>
          </div>
        </div>
        <div class="top-right">
          <div class="sn">预约编号：{{ curInfo.reserveSn }}</div>
          <div class="type">
            {{ Config.RESERCE_STATE_MAP[curInfo.reserveState] || '无' }}
          </div>
        </div>
      </a-row>

      <div class="medical-notice" v-if="isReserve">
        <span class="label">就诊须知:</span>
        <span>
          {{ curInfo.medicalNotice }}
        </span>
      </div>

      <a-row class="cTitle">预约信息</a-row>
      <a-row type="flex" class="cL" align="middle">
        <a-col :span="7">
          <span class="label">预约类型：</span>
          {{ ['线上问诊', '门诊就诊'][curInfo.revisitType - 1] || '无' || isEmpty }}
        </a-col>
        <a-divider style="height: 44px; margin-right: 16px" type="vertical" />
        <a-col :span="7">
          <span class="label">就诊医生：</span>
          {{ curInfo.doctorName || isEmpty }}
        </a-col>
        <a-divider style="height: 44px; margin-right: 16px" type="vertical" />
        <a-col :span="7">
          <span class="label">就诊科室：</span>
          {{ curInfo.department || isEmpty }}
        </a-col>
      </a-row>
      <a-row type="flex" class="cL" align="middle">
        <span class="label">就诊医院：</span>
        {{ curInfo.hospitalName || isEmpty }}
      </a-row>
      <a-row type="flex" class="cL" align="middle">
        <span class="label">就诊地址：</span>
        {{ curInfo.address || isEmpty }}
      </a-row>
      <a-row type="flex" class="cL" align="middle">
        <span class="label">预约就诊时间：</span>
        {{ handleTimeShowWeek(curInfo.reserveDate) || isEmpty }}
      </a-row>
      <a-row v-if="isReserve" type="flex" class="cL" align="middle">
        <span class="label">取号密码：</span>
        {{ curInfo.accessCipher || isEmpty }}
      </a-row>
      <a-row class="cTitle">问诊记录</a-row>
      <div v-if="curInfo.cureConsultHistory" class="inquiry">
        <div class="order_id">
          问诊订单：
          <span>{{ curInfo.cureConsultHistory.cureConsultId }}</span>
        </div>
        <div class="order_status">
          问诊状态：
          <span>{{ consultStatus[curInfo.cureConsultHistory.consultStatus] }}</span>
        </div>
        <div class="order_time">
          创建时间：
          <span>{{ curInfo.cureConsultHistory.createdAt }}</span>
        </div>
      </div>
      <a-row v-else class="empty" type="flex" justify="center">
        <auth-img src="@/assets/img/empty.png" mode="scaleToFill" />
      </a-row>
      <a-row class="cTitle">操作日志</a-row>
      <div v-if="curInfo.operationLog && curInfo.operationLog.length">
        <div class="logItem" v-for="item in curInfo.operationLog" :key="item">
          <div class="head">
            <span class="status"></span>
            <span class="time">{{ item.operatedAt }}</span>
          </div>
          <div class="sub">
            <span>{{ item.content }}</span>
            <span class="name">{{ item.accountType + '-' + item.operatedByName }}</span>
          </div>
          <div v-if="item.remark" class="remark">备注：{{ item.remark }}</div>
        </div>
      </div>
      <a-row class="empty" v-else type="flex" justify="center">
        <auth-img src="@/assets/img/empty.png" mode="scaleToFill" />
      </a-row>
      <slot name="footer" v-if="isReserve && curInfo.reserveState === 8">
        <div class="footer">
          <a-button class="foot-button" @click="showReserve = true" type="primary">
            取消预约
          </a-button>
        </div>
      </slot>
    </div>
    <!-- 取消挂号 成功/失败 -->
    <ModalReserve
      v-model:visible="showReserve"
      @refresh="initDetail"
      :ucDoctorId="curInfo.ucDoctorId"
      :reserveId="props.recordId"
      :curInfo="curInfo"
    ></ModalReserve>
  </a-modal>
</template>

<script setup>
import { defineProps, ref, defineExpose, reactive, computed } from 'vue'
import { appointRecordIdApi, appointReserveSnApi } from '@/api/workPlace/appoint'
import { handleTimeShowWeek } from '@/utils'
import Config from '@/config/index'
import ModalReserve from './ModalReserve'

const isEmpty = ref('--')
const consultStatus = reactive({
  0: '待问诊',
  1: '进行中',
  2: '问诊结束',
  3: '超时自动取消',
  4: '医生手动取消',
  5: '待接诊',
  21: '医生主动关闭',
  22: '医生拒诊',
  23: '医生超时未接诊'
})
const props = defineProps({
  recordId: {
    type: String,
    default: ''
  },
  reserveSn: {
    type: String,
    default: ''
  }
})
const showReserve = ref(false)
// 判断是不是 金华人民医院预约挂号
const isReserve = computed(() => {
  return curInfo.value.reserveType === 4
})
const curInfo = ref({})
const queryDetail = async query => {
  const Api = query.type ? appointRecordIdApi : appointReserveSnApi
  const { reserveId, reserveSn } = query
  const Query = query.type ? { reserveId } : { reserveSn }
  const result = await Api(Query)
  curInfo.value = { ...result }
  console.log('当前数据', curInfo.value)
}

const mVisible = ref(false)
const initDetail = () => {
  const query = props.recordId
    ? { reserveId: props.recordId, type: 1 }
    : { reserveSn: props.reserveSn, type: 0 }
  queryDetail(query)
}
defineExpose({
  mVisible,
  initDetail
})
</script>
<style lang="scss" scoped>
$tc: #666;
$lc: #333;
$texC: #999999;
$bc: #e8e8e8;
.aDetailWrap {
  padding: 0 24px 40px;
  .medical-notice {
    margin-top: 20px;
    padding: 8px 12px;
    color: #595959;
    font-size: 14px;
    background: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-weight: 400;

    .label {
      font-weight: 700;
      margin-right: 14px;
    }
  }
  .cL {
    padding: 16px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    .label {
      color: $texC;
    }
  }
  .cTitle {
    font-weight: 550;
    font-size: 16px;
    color: $lc;
    padding-top: 16px;
  }
  .top {
    &-left {
      display: flex;
      img {
        width: 52px;
        height: 52px;
        border: 1px solid #eee3;
        margin-right: 8px;
        border-radius: 4px;
      }
      .pat {
        padding: 4px 6px;
        background-color: #ffeed9;
        color: #ffa940;
        font-size: 12px;
        border-radius: 4px;
        line-height: 16px;
        margin-right: 4px;
      }
      .up {
        margin-bottom: 11px;
        &-t {
          color: $tc;
          font-weight: 500;
          font-size: 16px;
        }
      }
      .bot {
        color: $texC;
      }
    }
    &-right {
      text-align: right;
      .sn {
        font-size: 12px;
        color: $texC;
      }
      .type {
        font-weight: 500;
        font-size: 18px;
        color: #ffa940;
        margin-top: 8px;
      }
    }
  }

  .inquiry {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0 16px 0;
    border-bottom: 1px solid #e8e8e8;
    div {
      width: 200px;
      padding: 2px 0 2px 16px;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      border-right: 1px solid #e8e8e8;
      span {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
      }
    }
    div:first-child {
      padding-left: 0;
    }
    div:last-child {
      flex: 1;
      border: none;
    }
  }
  .logItem {
    margin-top: 12px;
    .head {
      display: flex;
      align-items: center;
    }
    .status {
      width: 8px;
      height: 8px;
      background: #3760fa;
      border-radius: 50%;
      margin-right: 12px;
    }
    .time {
      font-size: 12px;
    }
    .sub {
      margin: 10px 0 0 20px;
      color: $tc;
      .name {
        margin-left: 14.24px;
      }
    }
    .remark {
      font-size: 12px;
      color: #ff8926;
      margin: 10px 0 0 20px;
    }
  }
  .empty {
    img {
      width: 100px;
      height: 100px;
      display: block;
    }
  }
  .footer {
    margin-top: 8px;
    border-top: 1px solid #d9d9d9;
    padding-top: 14px;
    text-align: center;
    .foot-button {
      border-radius: 4px;
    }
  }
}
</style>
